import React from "react"
import { Link, graphql, useStaticQuery } from 'gatsby'
import NoteSlider from "./note-slider"
import InViewObserverForSideMenu from "../../functions/in-view-observer-for-side-menu"

export const NoteSlide = () => {
  const data = useStaticQuery (
    graphql`
    query NoteSlideQuery {
      noteForSlide: allMicrocmsNotes(
        limit: 4
        sort: {fields: [publishedAt], order: DESC}
      ) {
        edges {
          node {
            notesId
            title
            thumbnail {
              url
            }
            middle_category {
              id
              name
              display_color
            }
          }
        }
      }
    }`
  )

  return (
    <div className="gallery_area" id="note">
      <InViewObserverForSideMenu targetLiId={"noteLi"} />
      <div className="header_in note">
        <div className="note_head_wrap">
          <h1 className="w_logo">
            <Link className="logo" to="/note"><span>ジェイフィールのオウンドメディア</span>
          <div>J.Feel Note</div></Link>
          </h1>
          <div className="head_explanat">
            <span>
              ジェイフィールの探求が詰まったオウンドメディア、J.Feel Note 。<br />様々な活動を通して学んだ知見、生まれてきた想いなどを皆さんに共有します。<br className="pc_only" />
              一緒に考えを深めていきましょう。
            </span>
          </div>
        </div>
        <div className="quest_more"><Link to="/note/">Noteを見る</Link></div>
      </div>
      <div className="gallery">
        <NoteSlider data={data} />
      </div>
    </div>
  )
}

export default NoteSlide
